// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2PQWf","item":"PaymentsMobile_item__3nsDj","label":"PaymentsMobile_label__3sgnp","amount":"PaymentsMobile_amount__2Vko-"};